module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cs-row",
    class: 'cs-row--' + _vm.message.direction,
    attrs: {
      "data-testid": "chat-message",
      "data-msg-id": _vm.message.msgId,
      "data-direction": _vm.message.direction,
      "data-type": _vm.kind
    }
  }, [_c('div', {
    staticClass: "cs-bubble",
    class: ['cs-bubble--' + _vm.message.direction, {
      'cs-bubble--media': _vm.isMedia,
      'cs-bubble--tpl': _vm.kind === 'template' && _vm.resolved
    }]
  }, [(_vm.kind === 'text') ? _c('div', {
    staticClass: "cs-text",
    attrs: {
      "data-testid": "chat-text"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatted)
    }
  }), _c('span', {
    staticClass: "cs-time-pad"
  })]) : (_vm.kind === 'image') ? [(!_vm.mediaFailed) ? _c('img', {
    staticClass: "cs-image cs-image--zoom",
    attrs: {
      "data-testid": "chat-image",
      "src": _vm.payload.image.link,
      "alt": "image"
    },
    on: {
      "click": _vm.openImage,
      "error": function($event) {
        _vm.mediaFailed = true
      }
    }
  }) : _c('div', {
    staticClass: "cs-text cs-unsupported",
    attrs: {
      "data-testid": "chat-media-error"
    }
  }, [_c('span', [_vm._v("[image could not be loaded]")]), _c('span', {
    staticClass: "cs-time-pad"
  })])] : (_vm.kind === 'audio') ? [(!_vm.mediaFailed) ? _c('div', {
    staticClass: "cs-audio-wrap",
    attrs: {
      "data-testid": "chat-audio"
    }
  }, [_c('audio', {
    ref: "audio",
    attrs: {
      "src": _vm.payload.audio.link,
      "preload": "metadata"
    },
    on: {
      "loadedmetadata": _vm.onAudioMeta,
      "durationchange": _vm.onAudioMeta,
      "timeupdate": function($event) {
        _vm.audioCurrent = $event.target.currentTime
      },
      "play": function($event) {
        _vm.audioPlaying = true
      },
      "pause": function($event) {
        _vm.audioPlaying = false
      },
      "ended": _vm.onAudioEnded,
      "error": function($event) {
        _vm.mediaFailed = true
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "cs-audio-rate",
    attrs: {
      "type": "button",
      "data-testid": "chat-audio-rate"
    },
    on: {
      "click": _vm.cycleRate
    }
  }, [_vm._v(_vm._s(_vm.audioRate) + "×")]), _vm._v(" "), _c('button', {
    staticClass: "cs-audio-play",
    attrs: {
      "type": "button",
      "data-testid": "chat-audio-play",
      "aria-label": _vm.audioPlaying ? 'Pause' : 'Play'
    },
    on: {
      "click": _vm.toggleAudio
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.audioPlaying ? 'fa-pause' : 'fa-play'
  })]), _vm._v(" "), _c('div', {
    staticClass: "cs-audio-main"
  }, [_c('div', {
    staticClass: "cs-wave",
    attrs: {
      "data-testid": "chat-audio-wave"
    },
    on: {
      "click": _vm.seekAudio
    }
  }, [_vm._l((_vm.waveBars), function(h, i) {
    return _c('span', {
      key: i,
      staticClass: "cs-wave-bar",
      class: {
        'cs-wave-bar--played': i / _vm.waveBars.length <= _vm.audioProgress
      },
      style: ({
        height: h + 'px'
      })
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "cs-wave-dot",
    style: ({
      left: (_vm.audioProgress * 100) + '%'
    })
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "cs-audio-time",
    attrs: {
      "data-testid": "chat-audio-time"
    }
  }, [_vm._v(_vm._s(_vm.audioClock))])])]) : _c('div', {
    staticClass: "cs-text cs-unsupported",
    attrs: {
      "data-testid": "chat-media-error"
    }
  }, [_c('span', [_vm._v("[audio could not be loaded]")]), _c('span', {
    staticClass: "cs-time-pad"
  })])] : (_vm.kind === 'video_file') ? [(!_vm.mediaFailed) ? _c('video', {
    staticClass: "cs-video",
    attrs: {
      "data-testid": "chat-video",
      "src": _vm.payload.video.link,
      "controls": "",
      "preload": "metadata"
    },
    on: {
      "error": function($event) {
        _vm.mediaFailed = true
      }
    }
  }) : _c('div', {
    staticClass: "cs-text cs-unsupported",
    attrs: {
      "data-testid": "chat-media-error"
    }
  }, [_c('span', [_vm._v("[video could not be loaded]")]), _c('span', {
    staticClass: "cs-time-pad"
  })])] : (_vm.kind === 'document') ? _c('a', {
    staticClass: "cs-doc",
    attrs: {
      "data-testid": "chat-document",
      "href": _vm.payload.document.link,
      "download": _vm.payload.document.filename,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "cs-doc-meta"
  }, [_c('span', {
    staticClass: "cs-doc-name",
    attrs: {
      "data-testid": "chat-document-name"
    }
  }, [_vm._v(_vm._s(_vm.payload.document.filename))]), _vm._v(" "), _c('span', {
    staticClass: "cs-doc-size"
  }, [_vm._v(_vm._s(_vm.docSize))])])]) : (_vm.kind === 'video') ? _c('video', {
    staticClass: "cs-video",
    attrs: {
      "data-testid": "chat-video",
      "src": _vm.payload.text.body,
      "controls": "",
      "preload": "metadata"
    }
  }) : (_vm.isInteractiveBody) ? _c('div', {
    staticClass: "cs-text",
    attrs: {
      "data-testid": "chat-text"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.format(_vm.payload.interactive.body.text))
    }
  }), _c('span', {
    staticClass: "cs-time-pad"
  })]) : (_vm.kind === 'reply') ? _c('div', {
    staticClass: "cs-text",
    attrs: {
      "data-testid": "chat-text"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.replyTitle))]), _c('span', {
    staticClass: "cs-time-pad"
  })]) : (_vm.kind === 'location') ? _c('div', {
    staticClass: "cs-text",
    attrs: {
      "data-testid": "chat-text"
    }
  }, [_c('span', [_vm._v("📍 " + _vm._s(_vm.payload.location.latitude) + ", " + _vm._s(_vm.payload.location.longitude))]), _c('span', {
    staticClass: "cs-time-pad"
  })]) : (_vm.kind === 'template' && _vm.resolved) ? _c('div', {
    staticClass: "cs-tpl",
    attrs: {
      "data-testid": "chat-template"
    }
  }, [(_vm.resolved.header && _vm.resolved.header.type === 'image') ? _c('img', {
    staticClass: "cs-image cs-tpl-header",
    attrs: {
      "data-testid": "chat-image",
      "src": _vm.resolved.header.link,
      "alt": "header"
    }
  }) : (_vm.resolved.header && _vm.resolved.header.type === 'text') ? _c('div', {
    staticClass: "cs-text cs-tpl-title",
    attrs: {
      "data-testid": "chat-template-header"
    }
  }, [_vm._v(_vm._s(_vm.resolved.header.text))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cs-text cs-tpl-body",
    attrs: {
      "data-testid": "chat-text"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.format(_vm.resolved.body))
    }
  }), _c('span', {
    staticClass: "cs-time-pad"
  })]), _vm._v(" "), (_vm.resolved.footer) ? _c('div', {
    staticClass: "cs-tpl-footer",
    attrs: {
      "data-testid": "chat-template-footer"
    }
  }, [_vm._v(_vm._s(_vm.resolved.footer))]) : _vm._e()]) : (_vm.kind === 'template') ? _c('div', {
    staticClass: "cs-text cs-unsupported",
    attrs: {
      "data-testid": "chat-template"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" [Template: " + _vm._s(_vm.payload.template.name) + "]")]), _c('span', {
    staticClass: "cs-time-pad"
  })]) : _c('div', {
    staticClass: "cs-text cs-unsupported",
    attrs: {
      "data-testid": "chat-unsupported"
    }
  }, [_c('span', [_vm._v("[unsupported: " + _vm._s(_vm.payload.type) + "]")]), _c('span', {
    staticClass: "cs-time-pad"
  })]), _vm._v(" "), (_vm.caption) ? _c('div', {
    staticClass: "cs-text cs-caption",
    attrs: {
      "data-testid": "chat-caption"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.format(_vm.caption))
    }
  }), _c('span', {
    staticClass: "cs-time-pad"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "cs-time",
    class: {
      'cs-time--media': _vm.isMedia && !_vm.caption
    },
    attrs: {
      "data-testid": "chat-time"
    }
  }, [_vm._v(_vm._s(_vm.time)), (_vm.statusMark) ? _c('span', {
    staticClass: "cs-status",
    attrs: {
      "data-status": _vm.message.status,
      "data-testid": "chat-status"
    }
  }, [_vm._v(" " + _vm._s(_vm.statusMark))]) : _vm._e()]), _vm._v(" "), (_vm.kind === 'buttons') ? _c('div', {
    staticClass: "cs-actions",
    attrs: {
      "data-testid": "chat-buttons"
    }
  }, _vm._l((_vm.payload.interactive.action.buttons), function(b) {
    return _c('button', {
      key: b.reply.id,
      staticClass: "cs-action",
      attrs: {
        "type": "button",
        "data-testid": 'chat-button-' + b.reply.id,
        "data-button-id": b.reply.id,
        "disabled": _vm.disabled
      },
      on: {
        "click": function($event) {
          return _vm.$emit('reply', {
            id: b.reply.id,
            title: b.reply.title,
            type: 'button_reply',
            sourceMsgId: _vm.message.msgId
          })
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-reply"
    }), _vm._v(" " + _vm._s(b.reply.title) + "\n      ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.kind === 'list') ? _c('div', {
    staticClass: "cs-actions"
  }, [_c('button', {
    staticClass: "cs-action",
    attrs: {
      "type": "button",
      "data-testid": "chat-list-open",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.openList
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ul"
  }), _vm._v(" " + _vm._s(_vm.payload.interactive.action.button || 'Options') + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.kind === 'location_request') ? _c('div', {
    staticClass: "cs-actions"
  }, [_c('button', {
    staticClass: "cs-action",
    attrs: {
      "type": "button",
      "data-testid": "chat-location-btn",
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit('location', {
          sourceMsgId: _vm.message.msgId
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(" Share location\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.kind === 'template' && _vm.resolved && _vm.resolved.buttons && _vm.resolved.buttons.length) ? _c('div', {
    staticClass: "cs-actions",
    attrs: {
      "data-testid": "chat-buttons"
    }
  }, _vm._l((_vm.resolved.buttons), function(b, i) {
    return _c('button', {
      key: i,
      staticClass: "cs-action",
      attrs: {
        "type": "button",
        "data-testid": 'chat-button-' + i,
        "disabled": _vm.disabled
      },
      on: {
        "click": function($event) {
          b.type === 'URL' && b.url ? _vm.openUrl(b.url) : _vm.$emit('reply', {
            id: String(i + 1),
            title: b.text,
            type: 'button_reply',
            sourceMsgId: _vm.message.msgId
          })
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: b.type === 'URL' ? 'fa-external-link' : 'fa-reply'
    }), _vm._v(" " + _vm._s(b.text) + "\n      ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.kind === 'flow') ? _c('div', {
    staticClass: "cs-actions"
  }, [_c('button', {
    staticClass: "cs-action",
    attrs: {
      "type": "button",
      "data-testid": "chat-flow-btn",
      "disabled": "",
      "title": "WhatsApp Flows cannot run in the simulator"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v(" " + _vm._s(_vm.payload.interactive.action.parameters.flow_cta || 'Open form') + "\n      ")])]) : _vm._e()], 2), _vm._v(" "), (_vm.imageOpen) ? _c('div', {
    staticClass: "cs-viewer",
    attrs: {
      "data-testid": "chat-image-viewer"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeImage.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "cs-viewer-bar"
  }, [_c('span', {
    staticClass: "cs-viewer-time"
  }, [_vm._v(_vm._s(_vm.time))]), _vm._v(" "), _c('button', {
    staticClass: "cs-viewer-close",
    attrs: {
      "type": "button",
      "data-testid": "chat-image-close",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeImage
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cs-viewer-body",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeImage.apply(null, arguments)
      }
    }
  }, [_c('img', {
    staticClass: "cs-viewer-img",
    attrs: {
      "src": _vm.payload.image.link,
      "alt": "image"
    }
  })]), _vm._v(" "), (_vm.caption) ? _c('div', {
    staticClass: "cs-viewer-caption",
    attrs: {
      "data-testid": "chat-image-viewer-caption"
    }
  }, [_vm._v(_vm._s(_vm.caption))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.listOpen) ? _c('div', {
    staticClass: "cs-modal",
    attrs: {
      "data-testid": "chat-list-dialog"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeList.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "cs-dialog",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-label": _vm.payload.interactive.action.button || 'Options'
    }
  }, [_c('div', {
    staticClass: "cs-dialog-header"
  }, [_c('button', {
    staticClass: "cs-dialog-close",
    attrs: {
      "type": "button",
      "data-testid": "chat-list-close",
      "title": "Close"
    },
    on: {
      "click": _vm.closeList
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('span', {
    staticClass: "cs-dialog-title",
    attrs: {
      "data-testid": "chat-list-title"
    }
  }, [_vm._v(_vm._s(_vm.payload.interactive.action.button || 'Options'))])]), _vm._v(" "), _c('div', {
    staticClass: "cs-dialog-body",
    attrs: {
      "data-testid": "chat-list"
    }
  }, [_vm._l((_vm.listSections), function(section, si) {
    return [(section.title) ? _c('div', {
      key: 't' + si,
      staticClass: "cs-dialog-section"
    }, [_vm._v(_vm._s(section.title))]) : _vm._e(), _vm._v(" "), _vm._l((section.rows), function(r) {
      return _c('label', {
        key: si + '-' + r.id,
        staticClass: "cs-dialog-row",
        class: {
          'cs-dialog-row--selected': _vm.selectedRow && _vm.selectedRow.id === r.id
        },
        attrs: {
          "data-testid": 'chat-list-row-' + r.id,
          "data-row-id": r.id
        }
      }, [_c('span', {
        staticClass: "cs-dialog-text"
      }, [_c('span', {
        staticClass: "cs-dialog-row-title"
      }, [_vm._v(_vm._s(r.title))]), _vm._v(" "), (r.description) ? _c('span', {
        staticClass: "cs-dialog-row-desc"
      }, [_vm._v(_vm._s(r.description))]) : _vm._e()]), _vm._v(" "), _c('input', {
        staticClass: "cs-dialog-radio",
        attrs: {
          "type": "radio",
          "name": "cs-list-choice"
        },
        domProps: {
          "value": r.id,
          "checked": _vm.selectedRow && _vm.selectedRow.id === r.id
        },
        on: {
          "change": function($event) {
            _vm.selectedRow = r
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "cs-dialog-dot"
      })])
    })]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "cs-dialog-footer"
  }, [_c('button', {
    staticClass: "cs-dialog-send",
    attrs: {
      "type": "button",
      "data-testid": "chat-list-send",
      "disabled": !_vm.selectedRow
    },
    on: {
      "click": _vm.confirmList
    }
  }, [_vm._v("Send")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-cd20f0ea","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-simulator/MessageBubble.vue
// module id = 3iWb
// module chunks = 1